import styled from 'styled-components'

interface IExporterFormatFormStyledProps {}

export const ExporterFormatFormStyled = styled.div<IExporterFormatFormStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  .column-sort-container {
    padding: 0.5em;

    border: 1px solid ${(props) => props.theme.colors.content.border};
  }
`
